import { BridgeEvent } from 'types/legacy/wireframe';

import { BridgeConfig } from '../types';

export const bridgeConfig: BridgeConfig = {
    product_id: 'package',
    type: BridgeEvent.Event,
    action: null,
    data: null,
    correlation_id: '',
    plugin: 'pr',
};
